document.addEventListener('DOMContentLoaded', function () {
  var picker = document.querySelector('variant-picker');
  var bundle = document.querySelector('custom-bundle');
  if (!picker || !bundle) return;

  var mapping = {};
  try {
    mapping = JSON.parse(bundle.dataset.variantSlotMap || '{}');
  } catch (e) {
    console.error('bundle-variant-sync: mapping JSON invalide', e);
  }

  function applySlotCount(count) {
    if (!count) return;
    var slots = bundle.querySelectorAll('.cb-slot');
    slots.forEach(function (slot) {
      var index = parseInt(slot.dataset.slot, 10);
      slot.style.display = index <= count ? '' : 'none';
    });
    bundle.setAttribute('data-slot-count', count);
  }

  function getSelectedTitleFromDom() {
    var select = picker.querySelector('select');
    if (select) {
      var opt = select.options[select.selectedIndex];
      return opt ? opt.textContent.trim() : null;
    }
    var input = picker.querySelector('input[type="radio"]:checked');
    return input ? input.value : null;
  }

  function handleVariantPayload(variant) {
    var title = variant && variant.title ? variant.title : getSelectedTitleFromDom();
    if (title && mapping[title]) {
      applySlotCount(mapping[title]);
    }
  }

  picker.addEventListener('variant:updated', function (event) {
    var variant = (event.detail && (event.detail.variant || event.detail.data)) || event.detail;
    handleVariantPayload(variant);
  });

  picker.addEventListener('change', function () {
    setTimeout(function () {
      var title = getSelectedTitleFromDom();
      if (title && mapping[title]) {
        applySlotCount(mapping[title]);
      }
    }, 50);
  });

  var initialTitle = getSelectedTitleFromDom();
  if (initialTitle && mapping[initialTitle]) {
    applySlotCount(mapping[initialTitle]);
  }
});